import * as React from 'react';

import { Vanilla, VanillaAside, VanillaMain } from '@/layouts/Vanilla';

import { OnboardingChecklist } from '../../imports/ui/components/OnboardingChecklist';
import { MyGroupsPageContent } from './components/MyGroupsPageContent';

export const MyGroupsPage: React.FC = () => {
  return (
    <Vanilla>
      <VanillaMain>
        <MyGroupsPageContent />
      </VanillaMain>
      <VanillaAside>
        <OnboardingChecklist />
      </VanillaAside>
    </Vanilla>
  );
};







